// extracted by mini-css-extract-plugin
var _1 = "ChartAnchoredTooltipBox-modulebox__NSug6";
var _2 = "ChartAnchoredTooltipBox-moduleinside__M1vTD";
export { _1 as "box", _2 as "inside" }
